module.exports = __webpack_public_path__ + "static/media/careerCollage.2b847158.webp";